export const SECTION_SIMILAR_ITEMS_ACTION = 'SECTION_SIMILAR_ITEMS_ACTION';
export const SECTION_SIMILAR_ITEMS_SUCCESS_ACTION =
  'SECTION_SIMILAR_ITEMS_SUCCESS_ACTION';
export const SECTION_SIMILAR_ITEMS_FAILURE_ACTION =
  'SECTION_SIMILAR_ITEMS_FAILURE_ACTION';
